import styles from './create-new-duration-dialog.module.scss';
import { ChangeEvent, useContext, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { makeCourseRequest } from '../../../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, MenuItem, Select, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CreateNewDurationDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
}

export function CreateNewDurationDialog(props: CreateNewDurationDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const [loading, setLoading] = useState<boolean>(false);
  const [value, setValue] = useState<number>(0);
  const [unit, setUnit] = useState<string>("");

  const handleValueChange = (event: ChangeEvent<HTMLSelectElement>) => setValue(parseInt(event.target.value));
  const handleUnitChange = (event: ChangeEvent<HTMLSelectElement>) => setUnit(event.target.value);

  const missingFields = (): boolean => {
    const requiredFieldsFilled =
      value &&
      unit;
    return requiredFieldsFilled ? false : true;
  };

  const handleAddDuration = () => {
    setLoading(true);
    const body = {
      value: value,
      unit: unit
    }
    makeCourseRequest(`resource/duration/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('createNewDuration.addedNewDurationToList'), type: "info", });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('createNewDuration.couldNotAddNewDurationToList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.newDuration')}
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col xl={3}>
            <div className='mb-3'>
              <TextField
                label={<span>{t('createNewDuration.value')} &#42;</span>}
                name='value'
                fullWidth
                type='number'
                sx={{ minWidth: 100 }}
                value={value || null}
                onChange={handleValueChange}
              />
            </div>
          </Col>
          <Col xl={6}>
            <div className='mb-3'>
              <Select
                label={<span>{t('createNewDuration.unit')} &#42;</span>}
                name='unit'
                displayEmpty
                fullWidth
                sx={{ minWidth: 200 }}
                value={unit || ''}
                onChange={handleUnitChange}>
                <MenuItem key={0} value={'timer'}>{t('createNewDuration.hours')}</MenuItem>
                <MenuItem key={1} value={'dager'}>{t('createNewDuration.days')}</MenuItem>
              </Select>
            </div>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          onClick={handleAddDuration}
          disabled={loading || missingFields()}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('createNewDuration.addDuration')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreateNewDurationDialog;
